import {
  Text_16_24,
  Text_24_36,
  Text_40_50,
} from '@dreamstack/feature-components/src/layout/Texts'
import { useFormatToCurrencyCutoff, useFormatToDecimal } from '@dreamstack/i18n'
import { ArrowDownRight } from '@dreamstack/icons/src/icon-components/ArrowDownRight'
import { ArrowUpRight } from '@dreamstack/icons/src/icon-components/ArrowUpRight'
import { clsxMerge } from '@dreamstack/util'
import { cn } from '@dreamstack/util/src/cn'
import React, { Fragment, type FunctionComponent } from 'react'
import type { AverageTileData } from '../blocks/CustomBlocks/RegionGraphs/libs/useDataForAverageTiles'

export type RegionAverageTileExistingCustomProps = {
  region: string
}

const StyledTile: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...rest
}) => (
  <div
    className={cn(
      'p-px-24 flex flex-wrap flex-col justify-between font-semibold text-accentroWhite-full bg-accentroDarkGray-full',
      className
    )}
    {...rest}
  />
)

export const RegionAverageTile: FunctionComponent<
  React.PropsWithChildren<{
    data: AverageTileData
    className?: string
  }>
> = ({ data, className }) => {
  const formatToDecimal = useFormatToDecimal()
  const formatToCutoff = useFormatToCurrencyCutoff()
  const format =
    data.formatType === 'decimal' ? formatToDecimal : formatToCutoff
  const valueIsPositive = data.relativeChange >= 0
  return (
    <Fragment>
      <StyledTile className={className}>
        <Text_16_24 className="mb-px-32">{data.label}</Text_16_24>
        <div className="flex flex-col">
          <div className="flex items-baseline">
            <Text_40_50>{format(data.value)}</Text_40_50>
            {data.unit && (
              <Text_24_36 className="ml-px-8">{data.unit}</Text_24_36>
            )}
          </div>
          <div className="flex items-center">
            {valueIsPositive ? (
              <ArrowUpRight className="h-px-32 w-px-32 text-accentroLightGreen-full" />
            ) : (
              <ArrowDownRight className="h-px-32 w-px-32 text-accentroError-full" />
            )}
            <Text_16_24
              className={clsxMerge(
                'ml-px-4',
                valueIsPositive
                  ? 'text-accentroLightGreen-full'
                  : 'text-accentroError-full'
              )}
            >{`${data.relativeChange > 0 ? '+' : ''}${formatToDecimal(
              data.relativeChange
            )}%`}</Text_16_24>
          </div>
        </div>
      </StyledTile>
    </Fragment>
  )
}
